// removed by extract-text-webpack-plugin
module.exports = {"un-scroll":"un-scroll","un-scroll-pc":"un-scroll-pc","modal-open":"modal-open","HomePage__main":"HomePage__main","StandardPage__main":"StandardPage__main","modal-open-item":"modal-open-item","un-scroll-mb":"un-scroll-mb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/body/styles.css
// module id = 721
// module chunks = 0 1